import { defaultNamespace } from './default/index.js';

export const componentNamespaceFactory = (
  componentMap,
  fallbackSource = defaultNamespace
) =>
  new Proxy(componentMap, {
    get(target, prop) {
      return (target[prop] || fallbackSource?.[prop])?.component;
    },
  });
